export const changelogModalName = 'changelog';
